"use client";

import { createContext, useContext } from 'react';

const PortalContext = createContext<HTMLElement>(null);
export const PortalContextProvider = PortalContext.Provider;
export const usePortalContext = () => useContext(PortalContext);
